import React from 'react';
import { Banner, Button, UtilityAlertIcon } from '@placer-ui/components';
import { getErrorText, isAccountLockedError } from 'features/authentication/login-page/utils/utils';
import { isMobileWeb, shouldRenderMobileApp } from 'utils/detect-environment';
import { goToForgotPasswordPage } from 'router/go-to';
import { useSplunkCallback } from 'hooks/use-splunk-callback/use-splunk-callback';
import { forgotPasswordLinkClickSplunkData } from 'features/authentication/utils/constants';
import styles from './error-banner.module.scss';

type ErrorBannerProps = {
    errorCode: number;
    nextUrl?: string;
};

export const ErrorBanner = ({ errorCode, nextUrl = '' }: ErrorBannerProps) => {
    const isMobile = isMobileWeb() || shouldRenderMobileApp();
    const errorMessage = getErrorText(errorCode);
    const sendSplunkClickEvent = useSplunkCallback(forgotPasswordLinkClickSplunkData);

    const handleForgotPasswordClick = () => {
        sendSplunkClickEvent();
        goToForgotPasswordPage({
            nextUrl,
        });
    };

    const hasActionButton = isAccountLockedError(errorCode);

    return (
        <div className={styles.bannerContainer}>
            <Banner
                LeftIcon={<UtilityAlertIcon />}
                text={errorMessage}
                type="error"
                layout={isMobile && hasActionButton ? 'in-line' : undefined}
            >
                {errorCode && isAccountLockedError(errorCode) && (
                    <Button
                        onClick={handleForgotPasswordClick}
                        variant="secondary-gray"
                        size="small"
                        testId="error-banner-unlock-button"
                    >
                        Reset to unlock
                    </Button>
                )}
            </Banner>
        </div>
    );
};
